<template>
  <v-layout wrap class="custom-header">
    <header-values
      v-for="(item, index) in items"
      :key="index"
      v-bind="item"
      @clickHandler="item.clickHandler()"></header-values>
  </v-layout>
</template>

<script>
import HeaderValues from "@/components/shared/framework/cards/HeaderValues.vue"

export default {
  name: "SquadStatusHeader",
  components: {
    HeaderValues,
  },
  data() {
    return {
      items: [
        {
          layout: "left-side",
          icon: {
            path: require("@/assets/logos/BackBtn@3x.png").default,
          },
          clickHandler: () => {
            this.$router.go(-1)
          },
        },
        {
          title: "Squad Status",
          layout: "middle",
        },
        {
          layout: "right-side",
          clickHandler: () => {},
          icon: {
            // this is just to show that you can use Font awesome for these as well
            FAclass: "fas fa-bell theme--dark",
          },
        },
      ],
    }
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/globals.sass'
</style>
